export default "__VITE_ASSET__h7Zpy_pb__"